import React from 'react';
import Icon from '../../common/Icon';
import S from '../../styles/components';

class ListGroup extends React.PureComponent {
  state = {
    collapsed: true,
  };

  toggleCollapse = () => {
    const { collapsed } = this.state;

    this.setState({ collapsed: !collapsed });
  };

  handleClick = () => {
    const { value, onClick } = this.props;
    onClick(value);
  };

  render() {
    const { children, title, badge, indeterminate, selected } = this.props;
    const { collapsed } = this.state;
    return (
      <div>
        <S.ListGroupHeader>
          <S.ListItem>
            {false && (
              <S.ListItemExtra>
                <S.ListCheckbox
                  key={selected}
                  checked={selected}
                  indeterminate={indeterminate && !selected}
                  onClick={this.handleClick}
                />
              </S.ListItemExtra>
            )}
            <S.ListItemContent onClick={this.toggleCollapse} group={true}>
              <S.ListGroupMarker>
                {collapsed ? <Icon type="plus-square" /> : <Icon type="minus-square" />}
              </S.ListGroupMarker>
              <S.ListItemTitle>
                {title}
              </S.ListItemTitle>
              {badge !== undefined && (
                <S.ListItemBadge>
                  {badge}
                </S.ListItemBadge>
              )}
            </S.ListItemContent>
          </S.ListItem>
        </S.ListGroupHeader>
        <S.ListGroupBody collapsed={collapsed}>
          {children}
        </S.ListGroupBody>
      </div>
    );
  }
}

export default ListGroup;
